export default [
  { name: 'A Coruña', code: 'C' },
  { name: 'Álava', code: 'VI' },
  { name: 'Albacete', code: 'AB' },
  { name: 'Alicante', code: 'A' },
  { name: 'Almería', code: 'AL' },
  { name: 'Asturias', code: 'O' },
  { name: 'Ávila', code: 'AV' },
  { name: 'Badajoz', code: 'BA' },
  { name: 'Balears', code: 'PM' },
  { name: 'Barcelona', code: 'B' },
  { name: 'Burgos', code: 'BU' },
  { name: 'Cáceres', code: 'CC' },
  { name: 'Cádiz', code: 'CA' },
  { name: 'Cantabria', code: 'S' },
  { name: 'Castellón', code: 'CS' },
  { name: 'Ceuta', code: 'CE' },
  { name: 'Ciudad Real', code: 'CR' },
  { name: 'Córdoba', code: 'CO' },
  { name: 'Cuenca', code: 'CU' },
  { name: 'Girona', code: 'GI' },
  { name: 'Granada', code: 'GR' },
  { name: 'Guadalajara', code: 'GU' },
  { name: 'Guipúzcoa', code: 'SS' },
  { name: 'Huelva', code: 'H' },
  { name: 'Huesca', code: 'HU' },
  { name: 'Jaén', code: 'J' },
  { name: 'La Rioja', code: 'LO' },
  { name: 'Las Palmas', code: 'GC' },
  { name: 'León', code: 'LE' },
  { name: 'Lleida', code: 'L' },
  { name: 'Lugo', code: 'LU' },
  { name: 'Madrid', code: 'M' },
  { name: 'Málaga', code: 'MA' },
  { name: 'Melilla', code: 'ML' },
  { name: 'Murcia', code: 'MU' },
  { name: 'Navarra', code: 'NA' },
  { name: 'Ourense', code: 'OR' },
  { name: 'Palencia', code: 'P' },
  { name: 'Pontevedra', code: 'PO' },
  { name: 'Salamanca', code: 'SA' },
  { name: 'Santa Cruz de Tenerife', code: 'TF' },
  { name: 'Segovia', code: 'SG' },
  { name: 'Sevilla', code: 'SE' },
  { name: 'Soria', code: 'SO' },
  { name: 'Tarragona', code: 'T' },
  { name: 'Teruel', code: 'TE' },
  { name: 'Toledo', code: 'TO' },
  { name: 'Valencia', code: 'V' },
  { name: 'Valladolid', code: 'VA' },
  { name: 'Vizcaya', code: 'BI' },
  { name: 'Zamora', code: 'ZA' },
  { name: 'Zaragoza', code: 'Z' }
];
